import { PanelInfo } from 'types/Panel';
import { ArtistByStationFilter } from './types';

export function artistByStationFilterRequestTransformer(
  data: ArtistByStationFilter,
  defaultPanelInfo: PanelInfo,
): ArtistByStationFilter {
  return { ...data, PanelInfo: defaultPanelInfo };
}
